import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { usePriceUIContext } from "../PriceUIContext";
import { fetchSingleShopify } from "../../../actions/shopify-pricing/shopify";
import { deleteShopifyPricing } from "../../../actions/shopify-pricing/shopify";
import { fetchShopifyDataPricing } from "../../../actions/shopify-pricing/shopify";

export function PriceDeleteDialog({ show, onHide, id }) {

  // Products UI Context
  const priceUIContext = usePriceUIContext();
  const priceUIProps = useMemo(() => {
    return {
      ids: id,
      queryParams: priceUIContext.queryParams,
      setQueryParams: priceUIContext.setQueryParams,
    };
  }, [priceUIContext, id]);

  // Products Redux state
  const dispatch = useDispatch();

  const { enqueueSnackbar } = useSnackbar();



  // if there weren't selected products we should close modal
  useEffect(() => {
    if (!priceUIProps.ids || priceUIProps.ids.length === 0) {
      onHide();
    } else {
      dispatch(fetchSingleShopify(priceUIProps.ids));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, priceUIProps.ids]);

  const deleteShopify = () => {

    let query = {
      ...priceUIProps.queryParams,
      pageNumber: 1,
    }
    // server request for deleting product by seleted ids
    enableLoading();
    dispatch(deleteShopifyPricing(id)).then(async (data) => {

      await dispatch(fetchShopifyDataPricing(query));
      onHide();

      priceUIProps.setQueryParams({
        ...priceUIProps.queryParams,
        pageNumber: 1,
      })

      await enqueueSnackbar('Pricing plan deleted successfully', {
        variant: "success",
        autoHideDuration: 4500,
      });

      disableLoading();
    });
  };

  const [loading, setLoading] = useState(false);

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby='example-modal-sizes-title-lg'>
      {loading}
      <Modal.Header closeButton>
        <Modal.Title id='example-modal-sizes-title-lg'>
          Pricing plan Delete
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!loading && (
          <span>Are you sure you want to remove</span>
        )}
        {loading && <span>Please wait, Pricing plan is deleting...</span>}
      </Modal.Body>
      <Modal.Footer>
        <div>
          <button
            type='button'
            onClick={onHide}
            className='btn btn-light btn-elevate'>
            Cancel
          </button>
          <> </>
          <button
            type='button'
            onClick={deleteShopify}
            className='btn btn-primary btn-elevate'
            disabled={loading ? true : false}>
            Delete
            {loading && (
              <span className='ml-3 spinner px-2 spinner-white'></span>
            )}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
